import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20golden%20and%20crimson%20light%20streaks%2C%20film%20grain%20texture%2C%20dramatic%20spotlight%20effect%2C%20movie%20theater%20atmosphere%2C%20elegant%20Japanese%20and%20Korean%20cinema%20aesthetic%2C%20deep%20shadows%20with%20warm%20highlights%2C%20luxurious%20dark%20background&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="日韩影视网 - 免费日韩电影在线观看"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/40 to-background-950"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center pt-20">
        <h2 className="text-sm md:text-base text-accent-400 font-medium mb-4 tracking-widest uppercase font-label animate-[fadeIn_0.6s_ease-out]">
          高清画质 · 极速播放 · 完全免费
        </h2>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 mb-6 font-heading leading-tight animate-[fadeIn_0.8s_ease-out]">
          日韩影视网
          <span className="block text-xl md:text-2xl lg:text-3xl text-foreground-300 mt-3 font-normal">
            免费日韩电影在线观看
          </span>
        </h1>
        <p className="text-sm md:text-base text-foreground-400 max-w-[600px] mx-auto mb-8 leading-relaxed animate-[fadeIn_1s_ease-out]">
          最新日本电影、韩国电影免费在线观看，经典大片与新片速递一网打尽。高清流畅观影体验，随时随地想看就看。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-[fadeIn_1.1s_ease-out]">
          <Link
            to="/category/japanese-movie"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-950 font-semibold rounded-lg hover:bg-primary-400 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <i className="ri-sun-line mr-2"></i>日本电影
          </Link>
          <Link
            to="/category/korean-movie"
            className="w-full sm:w-auto px-8 py-3 bg-background-800/80 text-foreground-50 font-semibold rounded-lg border border-background-600 hover:bg-background-700 hover:border-background-500 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <i className="ri-star-line mr-2"></i>韩国电影
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 animate-[fadeIn_1.3s_ease-out]">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">5,000+</div>
            <div className="text-xs text-foreground-500 mt-1">部影片</div>
          </div>
          <div className="w-px h-10 bg-background-600"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">50万+</div>
            <div className="text-xs text-foreground-500 mt-1">日活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-600"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">1080P</div>
            <div className="text-xs text-foreground-500 mt-1">高清画质</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-foreground-500 text-xl"></i>
      </div>
    </section>
  );
}